export const PATH_SIGNIN = '/mb/mbb/SCR_MBB_0097A'
export const HOME = '/ds'
